export const getPaginationUrl = ({ pagePath, pageNumber, firstPagePath }) =>
    firstPagePath && pageNumber === 1 ? firstPagePath : pagePath.replace('{PAGE}', pageNumber);

export const getPreviousPageUrl = ({ pagePath, currentPage, firstPagePath }) =>
    getPaginationUrl({
        pagePath,
        pageNumber: currentPage - 1,
        firstPagePath,
    });

export const getNextPageUrl = ({ pagePath, currentPage, firstPagePath }) =>
    getPaginationUrl({
        pagePath,
        pageNumber: currentPage + 1,
        firstPagePath,
    });

export const getPaginationRange = ({ currentPage, numberOfPages, paginationSize }) => {
    let lowerLimit = Math.max(1, currentPage - Math.floor((paginationSize - 1) / 2));
    let upperLimit = Math.min(numberOfPages, currentPage + Math.floor(paginationSize / 2));

    if (currentPage < paginationSize) {
        lowerLimit = 1;
        upperLimit =
            numberOfPages >= paginationSize ? lowerLimit + paginationSize - 1 : numberOfPages;
    } else if (currentPage > numberOfPages - paginationSize + 1) {
        upperLimit = numberOfPages;
        lowerLimit = numberOfPages - paginationSize + 1;
    }

    return { lowerLimit, upperLimit };
};

export const getPaginationLinks = ({ currentPage, numberOfPages, paginationSize }) => {
    const paginationLinks = [];
    const { lowerLimit, upperLimit } = getPaginationRange({
        currentPage,
        numberOfPages,
        paginationSize,
    });

    for (let i = lowerLimit; i <= upperLimit; i++) {
        paginationLinks.push({
            pageNumber: i,
            isActive: i === currentPage,
        });
    }

    return paginationLinks;
};
